export default __webpack_public_path__ + "static/media/254.a2bdfd4c.gif";